import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { NEW_VIRTUAL_SUPPORT_STAGES, CONNECTION_STATUS_NAME } from 'app-constants'
import { STATICS } from 'statics'
import { setStage } from 'slices/drawer'
import { SignalInfo } from '../signal-info'
import './style.scss'

export function SignalVerify({ connectionStatusData }) {
  const dispatch = useDispatch()

  async function handleVerifyClick() {
    const isUnstable =
      connectionStatusData.status !== CONNECTION_STATUS_NAME.ONLINE || connectionStatusData.hasError

    if (isUnstable) dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.UNSTABLE_SIGNAL))
    else dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.STABLE_SIGNAL))
  }

  return (
    <div className='signal-verify'>
      <SignalInfo
        icon={STATICS.SIGNAL_CHECK}
        iconAlt='Sinal de internet'
        title='Verificação de sinal'
      >
        Para iniciar, vamos verificar o sinal da sua rede?
      </SignalInfo>
      <Button className='button-component -large' color='primary' onClick={handleVerifyClick}>
        Iniciar verificação
      </Button>
    </div>
  )
}
